import { useEffect, useState } from "react";
import { useTheme } from "./theme.jsx";

const VARS = ["--chart-1", "--chart-2", "--chart-3", "--chart-4", "--chart-5",
  "--primary", "--success", "--warning", "--critical", "--info",
  "--border", "--border-strong", "--surface", "--surface-2", "--muted", "--fg"];

function readVar(name) {
  if (typeof window === "undefined") return "0 0 0";
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || "0 0 0";
}

function toRgb(rgbStr, alpha) {
  // rgbStr is "R G B" with spaces. Convert to rgba(r,g,b,a)
  const parts = rgbStr.split(/\s+/).map(Number);
  const [r, g, b] = parts;
  if (alpha === undefined || alpha === 1) return `rgb(${r}, ${g}, ${b})`;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function useChartColors() {
  const { theme } = useTheme();
  const [palette, setPalette] = useState(() => buildPalette());

  useEffect(() => {
    // After theme switch, CSS vars need to settle — short timeout
    const id = setTimeout(() => setPalette(buildPalette()), 50);
    return () => clearTimeout(id);
  }, [theme]);

  return palette;
}

function buildPalette() {
  const raw = {};
  VARS.forEach(v => { raw[v] = readVar(v); });
  const get = (name, alpha) => toRgb(raw[name] || "0 0 0", alpha);
  return {
    chart: [1, 2, 3, 4, 5].map(i => get(`--chart-${i}`)),
    chartAlpha: (i, a) => get(`--chart-${i}`, a),
    primary: get("--primary"),
    primaryAlpha: a => get("--primary", a),
    success: get("--success"),
    warning: get("--warning"),
    critical: get("--critical"),
    info: get("--info"),
    border: get("--border"),
    borderStrong: get("--border-strong"),
    surface: get("--surface"),
    surface2: get("--surface-2"),
    muted: get("--muted"),
    fg: get("--fg"),
  };
}
